import {ProductsActions} from "../../reducers/products/ActionsNames";

export default function (phone: string) {
  return {
    type: ProductsActions.SubmitPhone,
    phone,
  };
}
